import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import classNames from 'classnames/bind';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Button from '@marvelapp/marvel-ui/button';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import SmartVideo from 'marketing-website/components/modules/SmartVideo';
import RevealWrapper from 'marketing-website/components/wrappers/RevealWrapper';

import styles from './style/block.module.css';

const cx = classNames.bind({ ...styles });

export default function VideoBlock({
  title,
  copy,
  isRightAligned,
  cloudinaryId,
  poster,
  maxVideoWidth,
  headingMaxWidth,
  paragraphMaxWidth,
}) {
  const flexClasses = cx('flex', { reverse: isRightAligned });

  return (
    <RevealWrapper>
      <div className={flexClasses}>
        <div className={styles.content}>
          <MaxWidth value={maxVideoWidth}>
            <SmartVideo
              name={cloudinaryId}
              autoPlay
              loop
              muted
              quality={95}
              maxWidth={maxVideoWidth}
              customPoster={poster}
            />
          </MaxWidth>
        </div>
        <div className={styles.text}>
          <HeadingBlock
            justify="center"
            maxWidth={paragraphMaxWidth}
            headingMaxWidth={headingMaxWidth}
            title={title}
            copy={copy}
            headingSize="xxxl"
            paragraphSize="l"
            spacing="s"
            tag="h3"
          >
            <Link to="/enterprise/request-demo">
              <Button size="large" kind="ghost" hover="blue" shape="rounded">
                Request a demo
              </Button>
            </Link>
          </HeadingBlock>
        </div>
      </div>
    </RevealWrapper>
  );
}

VideoBlock.propTypes = {
  copy: PropTypes.string,
  title: PropTypes.string,
  poster: PropTypes.string,
  cloudinaryId: PropTypes.string,
  maxVideoWidth: PropTypes.number,
  headingMaxWidth: PropTypes.number,
  paragraphMaxWidth: PropTypes.number,
  isRightAligned: PropTypes.bool,
};

VideoBlock.defaultProps = {
  isRightAligned: false,
};



// WEBPACK FOOTER //
// ./src/pages/enterprise/VideoBlock.js